import type { LedgerData } from "../types"

export const demoLedger: LedgerData = {
  profile: {
    id: "demo-admin",
    email: "owner@actiontracker.demo",
    display_name: "Harshit",
    role: "admin",
  },
  workspace: {
    id: "demo-workspace",
    owner_id: "demo-admin",
    name: "My Ledger",
    archived_at: null,
  },
  units: [
    { id: "apple", code: "apple", label: "Apple Pay", symbol: "", position: 10, archived_at: null },
    { id: "crypto", code: "crypto", label: "Crypto", symbol: "₿", position: 20, archived_at: null },
    { id: "gbp", code: "gbp", label: "GBP", symbol: "£", position: 30, archived_at: null },
    { id: "rs07", code: "rs07", label: "RS07", symbol: "🎮", position: 40, archived_at: null },
    { id: "cad", code: "cad", label: "CAD", symbol: "C$", position: 50, archived_at: null },
    { id: "rs3", code: "rs3", label: "RS3", symbol: "⚔", position: 60, archived_at: null },
  ],
  partners: [
    { id: "akame", name: "Akame", archived_at: null },
    { id: "gold", name: "Gold", archived_at: null },
    { id: "valk", name: "Valk", archived_at: null },
  ],
  bets: [
    {
      id: "bet-pending",
      kind: "hosted",
      status: "pending",
      unit_code: "apple",
      total_amount: "1000",
      owner_amount: "500",
      odds: "2.5",
      description: "Weekend action",
      source_url: "https://discord.com/channels/example",
      split_partner_id: null,
      created_at: "2026-09-09T08:30:00.000Z",
    },
    {
      id: "bet-won",
      kind: "split_in",
      status: "won",
      unit_code: "crypto",
      total_amount: "120",
      owner_amount: "120",
      odds: "1.8",
      description: "Match line",
      source_url: null,
      split_partner_id: "gold",
      created_at: "2026-09-08T12:30:00.000Z",
    },
  ],
  entries: [
    { id: "entry-1", partner_id: "akame", unit_code: "apple", amount: "250", kind: "adjustment", notes: "Previous tab", created_at: "2026-09-08T10:30:00.000Z" },
    { id: "entry-2", partner_id: "gold", unit_code: "crypto", amount: "120", kind: "bet_settlement", notes: "Match line won", created_at: "2026-09-08T12:45:00.000Z" },
    { id: "entry-3", partner_id: null, unit_code: "crypto", amount: "120", kind: "bet_settlement", notes: "Match line won", created_at: "2026-09-08T12:45:00.000Z" },
    { id: "entry-4", partner_id: "valk", unit_code: "gbp", amount: "-35", kind: "recorded_settlement", notes: "Collected", created_at: "2026-09-07T18:30:00.000Z" },
  ],
  auditEvents: [
    { id: "audit-1", actor_id: "demo-admin", workspace_id: "demo-workspace", action: "user.workspace_bootstrapped", metadata: {}, created_at: "2026-09-07T08:00:00.000Z" },
    { id: "audit-2", actor_id: "demo-admin", workspace_id: "demo-workspace", action: "bet.split_in_created", metadata: { bet_id: "bet-won", initial_status: "won" }, created_at: "2026-09-08T12:30:00.000Z" },
  ],
  adjustments: [
    { id: "adjustment-1", partner_id: "akame", unit_code: "apple", amount: "250", notes: "Previous tab", reversed_at: null, created_at: "2026-09-08T10:30:00.000Z" },
  ],
  balances: [
    { unit_code: "apple", unit_label: "Apple Pay", unit_symbol: "", partner_id: "akame", partner_name: "Akame", balance: "250" },
    { unit_code: "crypto", unit_label: "Crypto", unit_symbol: "₿", partner_id: "gold", partner_name: "Gold", balance: "120" },
    { unit_code: "gbp", unit_label: "GBP", unit_symbol: "£", partner_id: "valk", partner_name: "Valk", balance: "-35" },
  ],
  ownerTotals: [
    { unit_code: "crypto", unit_label: "Crypto", unit_symbol: "₿", total: "120" },
  ],
}
